import React from 'react';
import './Home.css';
import heroImage from '../Assets/wom2.png'; // Make sure this path is correct
import heroImage1 from '../Assets/Wom.png'; // Make sure this path is correct
import aboutImage from '../Assets/WEEM.png';

const Home = () => {
  return (
    <div className="homepage">
      {/* Hero Section with Two Column Layout */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-images">
            <div className="hero-image-container">
              <img src={heroImage} alt="Parity Empowerment" className="hero-image" />
            </div>
            <div className="hero-image-container">
              <img src={heroImage1} alt="Parity Empowerment" className="hero-image" />
            </div>
          </div>
          <div className="hero-text">
            <p className="hero-tagline">Parity Empowerment Initiative</p><br></br>
            <p className="hero-subheading">"Every Change Matters"</p>
            <h1 className="hero-heading">
              Make an <span className="impact-text">Impact</span>
            </h1>
            <p className="hero-description">
              Join us in creating positive change and empowering communities 
              through meaningful initiatives that make a real difference in people's lives.
            </p>
          </div>
        </div>
      </section>

      {/* Main Heading Section */}
      <section className="main-heading-section">
        <div className="main-heading-container">
          <h1 className="main-title">Parity Empowerment Initiative</h1>
          <p className="main-tagline">"Every Change Matters"</p>
        </div>
      </section>

      {/* About PEI Section */}
      <section className="about-pei-section">
        <div className="about-pei-container">
          <div className="about-pei-content">
            <div className="about-pei-text">
              <p>
                Parity Empowerment Initiative (PEI) is a feminist, community-based organization in Uganda working to advance the rights, dignity, and economic independence of ALL women. Our work centers women navigating layered exclusion shaped by poverty, gender-based violence, disability, displacement, HIV, criminalization, and limited access to formal economic systems particularly in rural and peri-urban contexts. We are grounded in the belief that economic independence is foundational to women's freedom, safety, and self-determination. Guided by our principle "Every Change Matters," PEI supports women to build sustainable livelihoods, strengthen collective power, and reduce long-term dependence on unstable or extractive systems.
              </p>
            </div>
            <div className="about-pei-image">
              <img src={aboutImage} alt="Women collaborating at PEI" />
            </div>
          </div>
        </div>
      </section>
     
      {/* Our Approach Section */}
      <section className="approach-section">
        <div className="approach-container">
          <h2 className="approach-title">Our Approach</h2>
          <div className="approach-cards">
            <div className="approach-card">
              <h3>Community-Led Solutions</h3>
              <p>Working alongside women and grassroots organizations to co-design economic initiatives rooted in lived experience.</p>
            </div>
            <div className="approach-card">
              <h3>Economic Sustainability</h3>
              <p>Moving beyond short-term skilling to support viable, income-generating enterprises.</p>
            </div>
            <div className="approach-card">
              <h3>Capacity Strengthening</h3>
              <p>Supporting women and women-led organizations with financial literacy, enterprise development, and organizational systems.</p>
            </div>
            <div className="approach-card">
              <h3>Strategic Partnerships</h3>
              <p>Collaborating with feminist movements, donors, and technical allies to expand reach and deepen impact.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map Section */}
      <section className="map-section">
        <div className="map-container">
          <h2 className="map-title">Find Us</h2>
          <div className="map-wrapper">
            <iframe
              title="Parity Empowerment Initiative Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7573454657!2d32.5825!3d0.3136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sKampala%2C%20Uganda!5e0!3m2!1sen!2sug!4v1234567890"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
      
    </div>
  );
};

export default Home;